import React from 'react';
import ProjectInfoWrapper from '../ProjectInfoWrapper';
import SNavigation from '../SNavigation';

const ProjectRoute = ({ projectID, page, codeID, rightSideBar, requiresExcerpts }) => (
  <ProjectInfoWrapper
    projectID={projectID}
  >
    <SNavigation
      page={page}
      rightSideBar={rightSideBar}
      codeID={codeID}
      requiresExcerpts={requiresExcerpts}
    />
  </ProjectInfoWrapper>
);

export default ProjectRoute;
